import { transformRoutes } from '../utils'
import { EmployeeTimeManagementAreaId } from './EmployeeTimeManagementAreaId'

const baseRoute = '/employee-time-management'

export const EmployeeTimeManagementAreaRoutes = transformRoutes({
  route: baseRoute,
  title: `${EmployeeTimeManagementAreaId}:Title`,
})
